import React, { useEffect } from "react";
import ModalLoadingFull from "../utils/ModalLoadingFull";
import { postNotification } from "../utils/Notifications";
import { urlParams } from "../utils/urlParams";
import { postData } from "../utils/APIUtilities";
import { scope } from "../environments";

import { getEnvironmentVariable } from "../global/environmentVariables";

const IS_DEV = getEnvironmentVariable("IS_DEV");
const IS_BCP = getEnvironmentVariable("IS_BCP");
const HOME_PAGE = getEnvironmentVariable("HOME_PAGE");
const ROOT_HOSTEDUI_DOMAIN = getEnvironmentVariable("ROOT_HOSTEDUI_DOMAIN");
const COGNITO_CLIENT_ID = getEnvironmentVariable("COGNITO_CLIENT_ID");

const storedClientId = sessionStorage?.getItem("client_id");
const { client_id } = urlParams();
const AUTH_CLIENT_ID = getEnvironmentVariable("AUTH_CLIENT_ID") || "web-app";

const delay = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

export default function LogOut() {
  const { redirect_uri, refresh_token } = urlParams();
  const _redirect_uri = localStorage.getItem("redirect_uri");

  const _scope = scope(client_id || storedClientId || AUTH_CLIENT_ID);
  const hasOIC = _scope?.filter((s) => s.type !== "cognito")?.length > 0;

  async function apiSignout() {
    if (refresh_token) {
      const customUrl = getEnvironmentVariable("API_URL").replace("/v1", "");
      await postData(
        `/oauth/logout`,
        {
          token: refresh_token,
          grant_type: "refresh_token",
        },
        null,
        customUrl,
      );
    }
  }

  async function mwSignout() {
    if (IS_BCP) {
      await delay(3000);
    }
  }
  async function logoutParallel() {
    const taskAPISignout = apiSignout();
    const taskMWSignout = mwSignout();

    return {
      apiSignout: await taskAPISignout,
      mwSignout: await taskMWSignout,
    };
  }

  useEffect(() => {
    const logout = async () => {
      try {
        await logoutParallel();
      } catch (err) {
        console.error(err);
        postNotification("error", err);
      } finally {
        if (hasOIC && ROOT_HOSTEDUI_DOMAIN) {
          try {
            let redirectURL = new URL(
              "/",
              redirect_uri || _redirect_uri || HOME_PAGE,
            );
            const hostedUISignout = `${ROOT_HOSTEDUI_DOMAIN}/logout?logout_uri=${redirectURL.origin}&response_type=CODE&client_id=${COGNITO_CLIENT_ID}&scope=aws.cognito.signin.user.admin+email+openid+phone+profile`;

            window.location.assign(hostedUISignout);
            return;
          } catch (err) {
            //
          }
        }
        window.location.assign(redirect_uri || _redirect_uri || HOME_PAGE);
      }
    };

    logout();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <ModalLoadingFull />
      {IS_BCP ? (
        <iframe
          height="0"
          width="0"
          style={{ visibility: "hidden", display: "none" }}
          title="My Warhammer Logout"
          src={
            IS_DEV
              ? "https://uat-warhammer.eu.auth0.com/logout"
              : "https://warhammer.eu.auth0.com/logout"
          }
        ></iframe>
      ) : (
        <></>
      )}
    </>
  );
}
